import { useFetchReleasesQuery } from "@/modules/docs/queries/fetch-reseases.query";
import { useEffect } from "react";
import { useMainStore } from "../stores/main.store";
import { version } from "./../../../../package.json";

export function useCheckNewVersion() {
	const {
		data: releasesData,
		isSuccess: isSuccessRequestReleases,
	} = useFetchReleasesQuery();

	const {
		actions: { setConfirmation, setCloseConfirmation },
	} = useMainStore();

	 useEffect(() => {
    if (isSuccessRequestReleases) {
      if (releasesData.currentRelease !== version) {
        setConfirmation({
          isOpen: true,
          timeout: 5000,
          message: "Há uma nova versão disponível, estamos atualizando...",
          onConfirm: async () => {
            const registrations = await navigator.serviceWorker.getRegistrations();
            for (const registration of registrations) {
              await registration.unregister();
            }
            const cacheKeys = await caches.keys();
            await Promise.all(cacheKeys.map(key => caches.delete(key)));
            localStorage.setItem("updateToVersion", releasesData.currentRelease);
            window.location.reload();
          },
          title: "Nova versão disponível",
          onClose: setCloseConfirmation,
        });
      }
    }
  }, [releasesData, isSuccessRequestReleases]);
}
